import { TextAreaContainer } from "./index.styled";



interface TextFieldProps {
    name: string;
    value?: string;
    placeholder?: string;
    onValueChange?: (value?: string) => void;
    maxLength?: number;
}
const TextArea: React.FC<TextFieldProps> = (props: TextFieldProps) => {
    const handleValueChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        if (!props.maxLength || value.length <= props.maxLength) {
            props.onValueChange?.(value);
        }
    };
    return (
        <TextAreaContainer>
            <textarea
                name={props.name}
                value={props.value}
                placeholder={props.placeholder}
                onChange={handleValueChange}
            />
            {props.maxLength && (
                <span id='counter'>
                    {props.value?.length}/{props.maxLength}
                </span>
            )}
        </TextAreaContainer>
    );
};
    
export default TextArea;
